import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

function NotificationComponent() {
  const notification = useSelector(({ uiState }) => uiState);
  const intl = useIntl();

  const text = notification.messageId
    ? intl.formatMessage(
        { id: notification.messageId, defaultMessage: notification.message },
        notification.values,
      )
    : notification.message;

  return (
    <Snackbar
      open={notification.open}
      TransitionComponent={TransitionUp}
      ContentProps={{
        "aria-describedby": "message-id",
      }}
      message={text}
    />
  );
}

export default NotificationComponent;
